import {
    Globe,
    ClipboardList,
    Send,
    SearchCheck,
    IndianRupee,
} from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
    {
        icon: Globe,
        title: "Visit DtOrbit",
        desc: "Go to DtOrbit and start your exchange.",
    },
    {
        icon: ClipboardList,
        title: "Enter Exchange Details",
        desc: "Provide the required USDT and payout information.",
    },
    {
        icon: Send,
        title: "Send USDT",
        desc: "Send USDT through the supported network.",
    },
    {
        icon: SearchCheck,
        title: "Verification",
        desc: "Transaction is checked and processed.",
    },
    {
        icon: IndianRupee,
        title: "Receive INR",
        desc: "Receive INR according to the exchange process.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            data-testid="how-it-works-section"
            className="relative py-16 md:py-24 scroll-mt-20 border-t border-[#E4EAF6] bg-white/60"
        >
            <div className="pointer-events-none absolute top-0 left-1/4 w-[380px] h-[380px] rounded-full bg-[#DFF4FD] blur-[120px]" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
                <Reveal>
                    <div className="max-w-2xl">
                        <span className="text-xs uppercase tracking-[0.25em] text-[#1E56FF] font-bold">
                            Process
                        </span>
                        <h2 className="font-display mt-3 text-3xl md:text-4xl font-bold tracking-tight text-[#0F1B3D]">
                            How USDT to INR Exchange Works
                        </h2>
                        <p className="mt-4 text-sm md:text-base text-[#5B6B8C] leading-relaxed">
                            Five simple steps from USDT to INR.
                        </p>
                    </div>
                </Reveal>

                <ol className="mt-12 md:mt-16 relative grid gap-10 lg:grid-cols-5 lg:gap-6">
                    <div className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-[2px] rounded-full flow-line-h" />
                    <div className="lg:hidden absolute left-8 top-8 bottom-8 w-[2px] rounded-full flow-line-v" />

                    {STEPS.map(({ icon: Icon, title, desc }, i) => (
                        <li key={title} className="relative">
                            <Reveal delay={i * 100}>
                                <div
                                    data-testid={`how-step-${i + 1}`}
                                    className="flex lg:flex-col items-start lg:items-center gap-5 lg:gap-0 lg:text-center"
                                >
                                    <div className="relative flex-none">
                                        <span className="relative z-10 inline-flex items-center justify-center w-16 h-16 rounded-2xl glass">
                                            <Icon className="w-6 h-6 text-[#1E56FF]" />
                                        </span>
                                        <span className="absolute -top-2 -right-2 z-20 inline-flex items-center justify-center min-w-[26px] h-[26px] px-1.5 rounded-full bg-gradient-to-br from-[#1E56FF] to-[#3EC6F0] text-[11px] font-extrabold text-white font-display shadow-[0_4px_14px_-4px_rgba(30,86,255,0.7)]">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                    </div>
                                    <div className="lg:mt-5">
                                        <h3 className="font-display text-base font-bold text-[#0F1B3D]">
                                            {title}
                                        </h3>
                                        <p className="mt-1.5 text-sm text-[#5B6B8C] leading-relaxed">
                                            {desc}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
